import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import Variables from '../../sass/_variables.scss'
import IconOneDay from '../components/Icons/IconOneDay/IconOneDay.vue';
import IconMultipleDays from '../components/Icons/IconMultipleDays/IconMultipleDays.vue';

Vue.use(Vuetify);

const opts = {
    icons: {
        iconfont: 'mdi',
        oneday: {
          component: IconOneDay
        },
        multipledays: {
          component: IconMultipleDays
        },
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: Variables.navy,
                secondary: Variables.turquoiseBlue,
                cancel: Variables.cancel,
                error: Variables.error,
                white: Variables.white,
                black: Variables.black,
                success: Variables.success
            }
        }
    }
}

export default new Vuetify(opts);
